import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

/**
 * Componente que monitorea la actividad del usuario y cierra la sesión
 * automáticamente tras N minutos de inactividad.
 */
const AutoLogout = ({ timeoutMinutes = 20 }) => {
  const navigate = useNavigate();
  const timerRef = useRef(null);

  const handleAutoLogout = () => {
    localStorage.clear();
    sessionStorage.clear();

    Swal.fire({
      icon: "warning",
      title: "Sesión Expirada",
      text: `Su sesión ha finalizado automáticamente por inactividad (${timeoutMinutes} minutos). Por favor inicie sesión de nuevo.`,
      confirmButtonColor: "#18234f",
      allowOutsideClick: false,
    }).then(() => {
      navigate("/", { replace: true });
    });
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];

    const resetTimer = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      const timeoutMs = timeoutMinutes * 60 * 1000;
      timerRef.current = setTimeout(handleAutoLogout, timeoutMs);
    };

    const usuario = localStorage.getItem("usuario") || sessionStorage.getItem("usuario");
    if (usuario) {
      events.forEach((event) => window.addEventListener(event, resetTimer));
      resetTimer();
    }

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [timeoutMinutes, navigate]);

  return null;
};

export default AutoLogout;
